import React,{ useState,useEffect } from 'react';
import '../App.css';
import Step1  from '../components/mobile/step_1';
import Step2  from '../components/mobile/step_2';
import Step3  from '../components/mobile/step_3';
import Step4  from '../components/mobile/step_4';
import Step5  from '../components/mobile/step_5';
import Step6  from '../components/mobile/step_6';
import Step7  from '../components/mobile/step_7';
// import Step8  from '../components/mobile/step_8';
import Step9  from '../components/mobile/step_9';
import { LeadsApi } from '../services/Apis';
import { useDispatch, useSelector } from 'react-redux';
import * as Actions from '../store/actions';
import Loading from '../components/loading';
import AlertSnackbar from '../components/Snackbar/Snackbar';
import RegisterUser from '../components/mobile/user';


function Mobile() {

  const dispatch = useDispatch();
  const [leadConfirmation, setLeadConfirmation] = useState(false);
  const { steps, loading } = useSelector(({register}) => register);
  const [isRegisterUser, setRegisterUser ] = useState(false);
  const [isRegisterDisabled, setRegisterDisabled] = useState(false);

  useEffect(() => {

    const  confirmLead = async (code) =>{
      
     let result = await LeadsApi.confirm(code);

      if(result && result.data ){
        dispatch(Actions.setLead(result.data));
        dispatch(Actions.setStep(1));
      }

      dispatch(Actions.setLoading(false));
     
    }

    if(!leadConfirmation ){

      let confirmation = window.location.pathname;
      if(confirmation){

        const query = new URLSearchParams(window.location.search);
        const token = query.get('t')

        if(confirmation === "/register/user"){
          if(token){
            setRegisterUser(true)
            return 
          }
          setRegisterDisabled(true);
          setLeadConfirmation(true);
          return;
        }
        
        dispatch(Actions.setLoading(true));
        confirmation = confirmation.replace("register/index.html","")
        confirmation = confirmation.replace("index.html","")
        confirmation = confirmation.replace("register","")
        confirmation = confirmation.replace("/","")
        
        setLeadConfirmation(true);

        if(confirmation && confirmation.length > 15){
          
          setLeadConfirmation(confirmation);
          confirmLead(confirmation);
        }else{
          setRegisterDisabled(true);
          dispatch(Actions.setLoading(false));
        }
       
      }
    }
    
  }, [leadConfirmation,dispatch ]);

  useEffect(() => {
    if (isRegisterDisabled) {
      document.title = '404 - Página não encontrada';
    }
  }, [isRegisterDisabled]);

  if(loading){

    return(
      <Loading/>
    )
  }

  if(isRegisterUser){
    return ( <RegisterUser/>)
  }

  if(isRegisterDisabled){
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: 24, textAlign: 'center' }}>
        <div>
          <p style={{ fontSize: 72, fontWeight: 700, color: '#4D39E9', marginBottom: 8, lineHeight: 1 }}>404</p>
          <p style={{ fontSize: 18, color: '#666' }}>Página não encontrada</p>
        </div>
        <div className="fixedMessage">
          <AlertSnackbar/>
        </div>
      </div>
    );
  }
 
  return (
    
    <>
      {steps === 0  &&(
        <Step1/>
      )}
      {steps === 1 &&(
        <Step2/>
      )}
      {steps === 2 &&(
        <Step3/>
      )}
      {steps === 3 &&(
        <Step4/>
      )}
      {steps === 4&&(
        <Step5/>
      )}
      {steps === 5&&(
        <Step6/>
      )}
      {steps === 6&&(
        <Step7/>
      )}
      {/* {steps === 7&&(
        <Step8/> 
      )}  */}
      {(steps === 7 || steps === 8)&&(
        <Step9/>
      )}
      <div className="fixedMessage">
        <AlertSnackbar/>
      </div>
    </>
  )
}

export default Mobile;

